import * as api from "../Api";

export const getAllStock = () => async (dispatch) => {
  try {
    const { data } = await api.getStock();
    dispatch({ type: "GET_ALL_STOCKS", payload: data });
  } catch (error) {}
};
